import React from 'react'

import styled from 'styled-components'

import AlertBadge from '../../../assets/icons/alert-badge.png'
import GreyAcorn from '../../../assets/logos/acorns-grey.svg'
import { theme } from '../../theme'

// Note: We render a full viewport-sized container to
// center the Loader component in
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background: ${theme('colors.ivory')};
`

const AlertContainer = styled.div`
  margin: 0 auto;
  max-width: 320px;
  text-align: center;
`

const AlertImg = styled.img`
  width: 100px;
  padding-bottom: 22px;
  margin: 0 auto;
`

const Message = styled.div`
  font-size: 14px;
  line-height: 1.57;
`

const Oops = styled.div`
  font-size: 22px;
  line-height: 1.36;
`

const AcornContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
`

const Acorn = styled.img`
  padding-top: 40px;
  width: 33px;
  margin: 0 auto;
`

export default () => (
  <Container>
    <AlertContainer>
      <AcornContainer>
        <Acorn src={GreyAcorn} />
      </AcornContainer>
      <AlertImg src={AlertBadge} />
      <Oops> Oops!</Oops>
      <Message>
        Sorry, we are having issues connecting to our servers. Please try again
        later.
      </Message>
    </AlertContainer>
  </Container>
)
